export default "__VITE_ASSET__C0h0Swd___"